import React, { useState, useEffect, useCallback, useRef, useMemo } from 'react'
import { Row, Col, Input, Timeline, Descriptions,
  Button, Table, message, Spin, Tabs, Modal, DatePicker, Upload, Form, Tag, Card, Empty } from 'antd'
import '../returnGoods/index.less'
import common from '@/public/common'
import _ from 'lodash'
import { set, get, cloneDeep } from 'lodash'
import moment from 'moment'
import { TablePipeline, features, BaseTable } from 'ali-react-table'
import '@/static/style/basetable.less'
import { UploadOutlined, LeftOutlined } from '@ant-design/icons'
import { getParmUrl, getCode, generateUUID } from '../../public/utils'
import { getDifferenceColumns } from './config'
import {
  fetchDeliveryDetail,
  fetchDeliveryDictionary,
  fetchLogisticsTrace,
  updateDeliveryExpectDate,
  exportDeliveryByCode,
  uploadAnnex,
  deleteAnnex,
  fetchAnnexList,
  fetchUploadToken,
  uploadToQiniu,
  downloadUdiTemplateNew,
} from './service'

const { TabPane } = Tabs

const statusMap = {
  subscribe: { label: '待提交', color: 'default' },
  awaiting: { label: '待收货', color: 'processing' },
  partinstock: { label: '收货中', color: 'warning' },
  invalid: { label: '已取消', color: 'error' },
  close: { label: '已完成', color: 'success' },
}

const renderText = (text) => <span>{text || text === 0 ? text : '--'}</span>
const renderDate = (text) => <span>{text ? moment(text).format('YYYY-MM-DD') : '--'}</span>

const DeliverDetailsNew = (props) => {
  const fileFormRef = useRef(null)

  const [sping, setSping] = useState(true)
  const [baseInfo, setBaseInfo] = useState({})
  const [detailList, setDetailList] = useState([])
  const [filteredDetailList, setFilteredDetailList] = useState([])
  const [search, setSearch] = useState({ ProductCode: '', ProductName: '' })
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [expectDate, setExpectDate] = useState(null)
  const [logisticsInfo, setLogisticsInfo] = useState([])
  const [differencepipelineState, setDifferencePipelineState] = useState({})
  const [fileList, setFileList] = useState({})
  const [activeKey, setActiveKey] = useState('product')
  const [fileLoading, setFileLoading] = useState({})
  const [changeLoading, setChangeLoading] = useState(false)
  const [companyMap, setCompanyMap] = useState({})
  const [warehouseMap, setWarehouseMap] = useState({})

  // 获取附件列表
  const getFilelistFn = useCallback(async (deliveryCode) => {
    if (!deliveryCode) return
    try {
      const res = await fetchAnnexList(deliveryCode)
      if (get(res, 'data.code') === '0') {
        const annexData = get(res, 'data.data') || []
        const mapAnnex = (type) => (get(annexData.find(i => i.annex_type === type), 'annex_list') || []).map(i => ({
          url: i.annex_url, name: i.annex_name, status: 'done', uid: generateUUID()
        }))
        setFileList({ UDI: mapAnnex('UDI'), report: mapAnnex('report'), other: mapAnnex('other') })
      }
    } catch (err) { console.log(err) }
  }, [])

  // 加载详情数据
  const loadData = useCallback(async () => {
    const deliveryCode = getParmUrl('DeliveryCode')
    if (!deliveryCode) return
    setSping(true)
    try {
      const res = await fetchDeliveryDetail({
        delivery_code: deliveryCode,
        service: 'scs',
      })
      if (String(res.data.code) === '0') {
        const respData = get(res, 'data.data') || {}
        const delivery = respData.page_info_list || respData.data || respData
        setBaseInfo(delivery)
        const list = get(delivery, 'detail_list') || []
        setDetailList(list)
        setFilteredDetailList(list)
        // 物流轨迹
        fetchLogisticsTrace({ delivery_code: deliveryCode }).then(traceRes => {
          if (String(get(traceRes, 'data.code')) === '0') {
            setLogisticsInfo(get(traceRes, 'data.data') || [])
          }
        }).catch(() => {})
        // 附件列表
        if (delivery.delivery_code) {
          getFilelistFn(delivery.delivery_code)
        }
      }
    } catch (err) { console.log(err) }
    finally { setSping(false) }
  }, [getFilelistFn])

  useEffect(() => {
    loadData()
    // 获取快递公司字典，构建 code→name 映射
    fetchDeliveryDictionary().then(res => {
      if (String(get(res, 'data.code')) === '0') {
        const dictData = get(res, 'data.data') || {}
        // 快递公司编码→名称
        const companyList = dictData.common_company_list || []
        const cMap = {}
        companyList.forEach(item => { cMap[item.key_value] = item.key_name })
        setCompanyMap(cMap)
        // 仓库编码→名称
        const whList = dictData.warehouse_list || []
        const wMap = {}
        whList.forEach(item => { wMap[item.key_value] = item.key_name })
        setWarehouseMap(wMap)
      }
    }).catch(() => {})
    if (getParmUrl('Files')) {
      setActiveKey('files')
    }
  }, [loadData])

  // 搜索货品
  const onSearch = () => {
    const code = (search.ProductCode || '').trim()
    const name = (search.ProductName || '').trim()
    if (!code && !name) {
      setFilteredDetailList(detailList)
      return
    }
    const filtered = detailList.filter(item => {
      const matchCode = code ? (get(item, 'product_code') || '').includes(code) : true
      const matchName = name ? (get(item, 'product_name') || '').includes(name) : true
      return matchCode && matchName
    })
    setFilteredDetailList(filtered)
  }

  // 导出
  const onExport = () => {
    exportDeliveryByCode(
      {
        delivery_code: baseInfo.delivery_code || '',
        product_code: search.ProductCode || '',
        product_name: search.ProductName || '',
      },
      '来货单_' + moment(new Date()).format('YYYYMMDDHHmmss') + '.xls'
    )
  }

  // 修改预计到货日期
  const openChangeDate = (e) => {
    setIsModalOpen(true)
    setExpectDate(get(baseInfo, 'expect_date') ? moment(get(baseInfo, 'expect_date')) : null)
    e && e.stopPropagation()
  }

  const handleOk = async () => {
    const expectDateLong = moment(expectDate).valueOf()
    if (!expectDate) {
      message.error('请选择预计到货日期')
      return
    }
    if (expectDateLong < moment().startOf('day')) {
      message.error('预计到货日期不能小于今天！')
      return
    }
    setChangeLoading(true)
    try {
      const res = await updateDeliveryExpectDate({
        delivery_code: get(baseInfo, 'delivery_code'),
        expect_date: expectDateLong,
      })
      if (String(res.data.code) === '0') {
        message.success('修改成功！')
        setTimeout(() => { window.location.reload() }, 1500)
      }
    } catch (err) {
      console.log(err)
      setIsModalOpen(false)
    }
  }

  const handleCancel = () => {
    setIsModalOpen(false)
    setExpectDate(null)
    setChangeLoading(false)
  }

  // 差异信息数据处理
  const setRolSpan = (list) => {
    list = list.map(item => {
      const diff_key = get(item, 'po_id') + '_' + get(item, 'product_id')
      return { ...item, diff_key, only_key: diff_key + '_' + get(item, 'batch_no') }
    })
    const cloneData = _.cloneDeep(list)
    list = list.map(item => {
      const newItem = { ...item }
      const sameList = _.filter(cloneData, ['diff_key', get(item, 'diff_key')])
      set(newItem, 'diff', _.cloneDeep(sameList))
      set(newItem, 'all_in_stock_quantity', _.sumBy(_.cloneDeep(sameList), 'in_stock_quantity'))
      const all_is_diff = _.sumBy(_.cloneDeep(sameList), 'qty') != get(newItem, 'all_in_stock_quantity')
      const batch_is_diff = get(newItem, 'qty') != get(newItem, 'in_stock_quantity')
      let diff_info = all_is_diff ? '总数有差异' : '总数无差异'
      diff_info = diff_info + (get(newItem, 'batch_no') && batch_is_diff ? '，批次有差异' : '，批次无差异')
      set(newItem, 'diff_info', diff_info)
      set(newItem, 'diff_key_diff_info', get(item, 'diff_key') + diff_info)
      set(newItem, 'diff_key_all_in_stock_quantity', get(item, 'diff_key') + get(newItem, 'all_in_stock_quantity'))
      return newItem
    })
    return list
  }

  const diffPipeline = useMemo(() => {
    const diffList = detailList.flatMap(item => get(item, 'diff_detail_list') || [])
    if (!diffList.length) return null
    const pipeline = new TablePipeline({
      state: differencepipelineState,
      setState: (updater) => {
        setDifferencePipelineState(prev => updater(prev.pipelineState || prev))
      }
    })
    pipeline.input({ dataSource: setRolSpan(diffList), columns: getDifferenceColumns() })
    pipeline.primaryKey('only_key')
    pipeline.use(features.autoRowSpan())
    return pipeline
  }, [detailList, differencepipelineState])

  // 附件上传
  const beforeUpload = async (type, file) => {
    setFileLoading(prev => ({ ...prev, [type]: true }))
    try {
      const tokenRes = await fetchUploadToken([file.name])
      const fileNames = get(tokenRes, 'data.file_names[0]')
      const upTokens = get(tokenRes, 'data.up_tokens[0]')
      const form = new FormData()
      form.append('token', upTokens)
      form.append('file', file)
      form.append('key', fileNames)
      const uploadRes = await uploadToQiniu(form)
      if (get(uploadRes, 'data.hash') && get(uploadRes, 'data.key')) {
        const param = {
          delivery_code: get(baseInfo, 'delivery_code'),
          annex_name: file.name,
          annex_type: type,
          key: fileNames,
          source: 'scs',
          operator: getCode()
        }
        const res = await uploadAnnex(param)
        if (get(res, 'data.code') === '0') {
          const imgUrl = `${common.fileUrl}/${get(uploadRes, 'data.key')}`
          setFileList(prev => {
            const newList = cloneDeep(prev)
            if (get(newList, `${type}.length`)) {
              newList[type].push({ uid: file.uid, name: file.name, status: 'done', url: imgUrl })
            } else {
              newList[type] = [{ uid: file.uid, name: file.name, status: 'done', url: imgUrl }]
            }
            return newList
          })
        } else {
          message.error(get(res, 'data.message'))
        }
      }
      setFileLoading(prev => ({ ...prev, [type]: false }))
      return false
    } catch (err) {
      setFileLoading(prev => ({ ...prev, [type]: false }))
      return false
    }
  }

  const onRemove = async (type, file) => {
    const param = {
      delivery_code: get(baseInfo, 'delivery_code'),
      annex_name: file.name,
      source: 'scs',
      operator: getCode(),
    }
    try {
      const res = await deleteAnnex(param)
      if (get(res, 'data.code') === '0') {
        setFileList(prev => {
          const newList = cloneDeep(prev)
          newList[type] = (newList[type] || []).filter(item => item.uid != file.uid)
          return newList
        })
      } else {
        message.error(get(res, 'data.message'))
      }
    } catch (err) { console.log(err) }
  }

  const deliveryStatus = get(baseInfo, 'delivery_status')
  const statusCfg = statusMap[deliveryStatus] || { label: deliveryStatus || '--', color: 'default' }

  const columns = useMemo(() => [
    { title: '采购单号', dataIndex: 'purchase_code', width: 220, render: renderText },
    {
      title: '货品名称/编码',
      dataIndex: 'product_name',
      width: 180,
      render: (text, record) => (
        <span>
          {text || '--'}<br />
          <span style={{ color: '#999', fontSize: 12 }}>{get(record, 'product_code') || '--'}</span>
        </span>
      )
    },
    { title: '供应商货品编码', dataIndex: 'supplier_product_code', width: 150, render: renderText },
    { title: '规格型号', dataIndex: 'pro_model', width: 120, render: renderText },
    { title: '注册证号', dataIndex: 'mdrc', width: 160, render: renderText },
    { title: '注册人/备案人', dataIndex: 'register_name', width: 120, render: renderText },
    { title: '生产企业', dataIndex: 'producer', width: 150, render: renderText },
    { title: '单位', dataIndex: 'unit', width: 60, render: renderText },
    { title: '批次号', dataIndex: 'batch_no', width: 120, render: renderText },
    { title: '生产日期', dataIndex: 'production_date', width: 110, render: renderDate },
    { title: '失效日期', dataIndex: 'expiry_date', width: 110, render: renderDate },
    { title: '大箱号', dataIndex: 'big_box_code', width: 100, render: renderText },
    { title: '小箱号', dataIndex: 'small_box_code', width: 100, render: renderText },
    { title: '发货数量', dataIndex: 'qty', width: 80, align: 'right', render: renderText },
    { title: '入库数量', dataIndex: 'in_stock_quantity', width: 80, align: 'right', render: renderText },
  ], [])

  return (
    <div className="returnList" style={{ padding: '16px' }}>
      <Spin spinning={sping}>
        {/* 基本信息卡片 */}
        <Card
          title={
            <span>
              来货单详情
              <Tag style={{ marginLeft: 12 }} color={statusCfg.color}>{statusCfg.label}</Tag>
            </span>
          }
          style={{ marginBottom: 16 }}
          extra={<Button type="link" icon={<LeftOutlined />} onClick={() => props.history.push('/main/deliverGoodsNew/deliverList')}>返回列表</Button>}
        >
          <Descriptions column={3} bordered size="small" labelStyle={{ width: 100, fontWeight: 500 }}>
            <Descriptions.Item label="来货单号">
              {baseInfo.delivery_code || '--'}
            </Descriptions.Item>
            <Descriptions.Item label="采购主体">
              {baseInfo.po_subject_name || '--'}
            </Descriptions.Item>
            <Descriptions.Item label="仓库">
              {baseInfo.warehouse_name || warehouseMap[baseInfo.warehouse_code] || baseInfo.warehouse_code || '--'}
            </Descriptions.Item>
            <Descriptions.Item label="采购单号">
              {get(baseInfo, 'purchase_code_list.length') ? baseInfo.purchase_code_list.join(', ') : '--'}
            </Descriptions.Item>
            <Descriptions.Item label="是否代发">
              {baseInfo.is_supplier_delivery ? '是' : '否'}
            </Descriptions.Item>
            <Descriptions.Item label="生成方式">
              {baseInfo.generate_method_name || '--'}
            </Descriptions.Item>
            <Descriptions.Item label="预计到货日期">
              {baseInfo.expect_date ? moment(baseInfo.expect_date).format('YYYY-MM-DD') : '--'}
              {deliveryStatus === 'awaiting' && (
                <a onClick={openChangeDate} style={{ marginLeft: 8, fontSize: 12 }}>修改</a>
              )}
            </Descriptions.Item>
            <Descriptions.Item label="物流公司">
              {baseInfo.logistics_name || companyMap[baseInfo.logistics_company_code] || baseInfo.logistics_company_code || '--'}
            </Descriptions.Item>
            <Descriptions.Item label="物流单号">
              {baseInfo.logistics_code || '--'}
            </Descriptions.Item>
            <Descriptions.Item label="创建人">
              {baseInfo.create_user_name || '--'}
            </Descriptions.Item>
            <Descriptions.Item label="创建时间">
              {baseInfo.create_time ? moment(baseInfo.create_time).format('YYYY-MM-DD HH:mm:ss') : '--'}
            </Descriptions.Item>
            <Descriptions.Item label="来货数量">
              {baseInfo.sum_quantity != null ? baseInfo.sum_quantity : '--'}
            </Descriptions.Item>
            <Descriptions.Item label="入库数量">
              {baseInfo.sum_in_stock_quantity != null ? baseInfo.sum_in_stock_quantity : '--'}
            </Descriptions.Item>
            <Descriptions.Item label="WMS状态">
              {baseInfo.wms_status_name || '--'}
            </Descriptions.Item>
            <Descriptions.Item label="备注">
              {baseInfo.remark || '--'}
            </Descriptions.Item>
          </Descriptions>
        </Card>

        {/* Tabs */}
        <Tabs type="card" activeKey={activeKey} onChange={(e) => { setActiveKey(e) }} style={{ marginTop: 16 }}>
          <TabPane tab="货品明细" key="product">
            <div style={{ padding: '16px 0' }}>
              <div style={{ marginBottom: 16 }}>
                <span>货品编码：</span>
                <Input style={{ width: 180, marginRight: 16 }} value={search.ProductCode}
                  onChange={(e) => setSearch(prev => ({ ...prev, ProductCode: e.target.value }))} placeholder="货品编码" />
                <span>货品名称：</span>
                <Input style={{ width: 180, marginRight: 16 }} value={search.ProductName}
                  onChange={(e) => setSearch(prev => ({ ...prev, ProductName: e.target.value }))} placeholder="货品名称" />
                <Button type="primary" onClick={onSearch}>查询</Button>
                <Button style={{ marginLeft: 12 }} onClick={onExport}>导出</Button>
              </div>
              <Table
                bordered
                size="small"
                columns={columns}
                dataSource={filteredDetailList}
                pagination={filteredDetailList.length > 20 ? { pageSize: 20, showTotal: (t) => `共 ${t} 条` } : false}
                rowKey={(record, index) => record.id || index}
                scroll={{ x: 1800 }}
              />
            </div>
          </TabPane>

          <TabPane tab="物流信息" key="logisticsInfo">
            <div style={{ padding: '16px 0' }}>
              <Card size="small" title="物流轨迹" style={{ marginBottom: 16 }}>
                {get(logisticsInfo, 'length') > 0
                  ? <Timeline>
                    {logisticsInfo.map((item, idx) => (
                      <Timeline.Item key={idx} style={{ color: idx === 0 ? '#ffa500' : '' }}>
                        <div>{moment(get(item, 'time')).format('YYYY/MM/DD HH:mm:ss')}</div>
                        <div style={{ maxWidth: '500px' }}>{get(item, 'content')}</div>
                      </Timeline.Item>
                    ))}
                  </Timeline>
                  : <Empty description="暂无物流信息" />
                }
              </Card>
            </div>
          </TabPane>

          <TabPane tab="差异信息" key="diff">
            <div style={{ padding: '16px 0' }}>
              {diffPipeline
                ? <div className='BaseTable'>
                  <BaseTable
                    isStickyHead
                    className='antd_table_style no_border'
                    {...diffPipeline.getProps()}
                  />
                </div>
                : <Empty description="暂无差异信息" />
              }
            </div>
          </TabPane>

          <TabPane tab="发货附件" key="files">
            <div style={{ padding: '16px 0' }}>
              <Row>
                <Col span={8}>
                  <Form
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 18 }}
                    ref={fileFormRef}>
                    <Form.Item
                      name='UDI'
                      label="UDI附件："
                      getValueFromEvent={() => fileList.UDI || []}
                    >
                      <Upload
                        accept=".xls, .xlsx"
                        fileList={fileList.UDI || []}
                        beforeUpload={(file) => { beforeUpload('UDI', file); return false }}
                        onRemove={(file) => { onRemove('UDI', file) }}
                      >
                        <Button icon={<UploadOutlined />} loading={fileLoading && fileLoading.UDI}>Excel导入</Button>
                      </Upload>
                      <a
                        style={{ position: 'absolute', top: 8, left: 120 }}
                        onClick={() => { downloadUdiTemplateNew() }}>
                        下载模板
                      </a>
                    </Form.Item>
                    <Form.Item
                      name='report'
                      label="质量检测报告："
                      getValueFromEvent={() => fileList.report || []}
                    >
                      <Upload
                        accept=".jpg, .jpeg, .png, .gif, .doc, .docx, .xls, .xlsx, .pdf, .zip, .rar"
                        fileList={fileList.report || []}
                        beforeUpload={(file) => { beforeUpload('report', file); return false }}
                        onRemove={(file) => { onRemove('report', file) }}
                      >
                        <Button icon={<UploadOutlined />} loading={fileLoading && fileLoading.report}>上传文件</Button>
                        <span style={{ color: 'gray', marginLeft: 8 }}>
                          支持拓展名：.rar .zip .doc .docx .pdf .jpg ...
                        </span>
                      </Upload>
                    </Form.Item>
                    <Form.Item
                      name='other'
                      label="其他附件："
                      getValueFromEvent={() => fileList.other || []}
                    >
                      <Upload
                        accept=".jpg, .jpeg, .png, .gif, .doc, .docx, .xls, .xlsx, .pdf, .zip, .rar"
                        fileList={fileList.other || []}
                        beforeUpload={(file) => { beforeUpload('other', file); return false }}
                        onRemove={(file) => { onRemove('other', file) }}
                      >
                        <Button icon={<UploadOutlined />} loading={fileLoading && fileLoading.other}>上传文件</Button>
                        <span style={{ color: 'gray', marginLeft: 8 }}>
                          支持拓展名：.rar .zip .doc .docx .pdf .jpg ...
                        </span>
                      </Upload>
                    </Form.Item>
                  </Form>
                </Col>
              </Row>
            </div>
          </TabPane>
        </Tabs>

        <Modal title="修改预计到货日期"
          open={isModalOpen}
          onCancel={handleCancel}
          footer={[
            <Button key="cancel" onClick={handleCancel}>取消</Button>,
            <Button key="submit" type='primary' onClick={handleOk} loading={changeLoading}>提交</Button>
          ]}
        >
          <div>
            <span>预计到货日期：</span>
            <DatePicker
              value={expectDate}
              disabledDate={(current) => current && current < moment().startOf('day')}
              onChange={setExpectDate}
            />
          </div>
        </Modal>
      </Spin>
    </div>
  )
}

export default DeliverDetailsNew


// WEBPACK FOOTER //
// ./src/pages/deliverGoodsNew/deliverDetails.js